import { render, staticRenderFns } from "./SubjectsWithdrawnReport.vue?vue&type=template&id=51643cf6&"
import script from "./SubjectsWithdrawnReport.vue?vue&type=script&lang=js&"
export * from "./SubjectsWithdrawnReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports